export default {
  blogHelpers: (state) => state.blogHelpers,
  blog: (state) => state.blog
}



// WEBPACK FOOTER //
// ./src/components/blog/store/getters.js